import Head from 'next/head';
import { func } from '../helpers';

export default function AppHead(props) {

    const keywords = [
        'online voting', 'e-voting', 'e-ticketing', 'cast vote', 'online voting ghana', 'voting hub gh', 'VotingHubGH', 'castvotegh',
        'tease', 'online voting nigeria', 'online voting ivory coast', 'online voting cote d\'ivoire',
    ];

    return (
        <Head>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <base href="/" />

            <title>{`${props.title ? props.title + ' - FayaVotes' : 'FayaVotes'}` || 'FayaVotes | Your 360° e-voting platform'}</title>
            <meta property="og:title" content={`${props.title} - FayaVotes` || 'FayaVotes | Your 360° e-voting & e-ticketing platform'} />
            <meta property="og:locale" content="en_US" />
            <meta name="description" content={props.description || 'Your 360° e-voting, e-ticketing platform'} />
            <meta property="og:description" content={props.description || 'Your 360° e-voting, e-ticketing platform'} />
            <meta name="keywords" content={props.keywords || keywords.join(',')} />
            <meta property="og:keywords" content={props.keywords || keywords.join(',')} />

            <meta property="og:url" content={`${props.url || ''}`} />
            <link rel="canonical" href={`${props.url || ''}`} />
            <meta property="og:site_name" content="FayaVotes" />
            <meta property="og:type" content="application" />
            <meta property="article:publisher" content="Anchora Technologies Ltd" />
            <meta property="og:image" content={props.image || 'assets/img/logo.png'} />

            <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />

            <meta name="mobile-web-app-capable" content="yes" />
            <meta name="application-name" content="FayaVotes" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-status-bar-style" content="black" />
            <meta name="apple-mobile-web-app-title" content="FayaVotes" />
            <meta name="theme-color" content="#042893" />
            <link rel="icon" sizes="192x192" href={`assets/img/icon.png?v=${func.app.version}`} />
        </Head>
    );
}